import React, { useState } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import { createStyles, makeStyles } from "@mui/styles";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import NavLink from "../NavLink";
import { useIntl } from "react-intl";
import PageRoute from "../../../constant/pageRouteDictionary.json";

import { useDispatch } from "react-redux";
import { setCurrentPage } from "../../../actions";

const useStyles = makeStyles(theme =>
  createStyles({
    menuPaper: {
      marginTop: 35,
    },
    menuItem: {
      fontSize: 12,
      textTransform: "uppercase",
      fontWeight: 600,
    },
  })
);

const NavMenu = ({ menu, onWorkspaceClick }) => {
  const intl = useIntl();
  const classes = useStyles();
  const location = useLocation();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);

  const currentPage = Object.keys(PageRoute).find(
    key => PageRoute[key] === location.pathname
  );

  const openMenu = (event) => {
    if (menu.childMenu?.length > 0) {
      setAnchorEl(event.currentTarget);
    }
  };

  const closeMenu = () => {
    setAnchorEl(null);
  };

  const handleClick = () => {
    dispatch(
      setCurrentPage({
        page: menu.page,
        name: menu.name,
        params: menu.params,
      })
    );

    if (menu.page === "workspaceOverview" && onWorkspaceClick) {
      onWorkspaceClick();
    }

    closeMenu();
  };

  return (
    <>
      <NavLink
        label={
          menu.name?.trim() ||
          intl.formatMessage({ id: `pageKey.${menu.page}` })
        }
        hasChild={Boolean(menu.childMenu?.length)}
        open={Boolean(anchorEl)}
        link={PageRoute[menu.page] || "/"}
        onClick={handleClick}
        selected={currentPage === menu.page}
      />

      {menu.childMenu && (
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={closeMenu}
          classes={{ paper: classes.menuPaper }}
        >
          {menu.childMenu.map((x, idx) => (
            <MenuItem
              key={`navmenu-${idx}`}
              onClick={closeMenu}
              className={classes.menuItem}
            >
              <NavLink
                label={
                  x.name?.trim() ||
                  intl.formatMessage({ id: `pageKey.${x.page}` })
                }
                link={PageRoute[x.page] || "/"}
                selected={currentPage === x.page}
                onClick={() =>
                  dispatch(
                    setCurrentPage({
                      page: x.page,
                      name: x.name,
                      params: x.params,
                    })
                  )
                }
              />
            </MenuItem>
          ))}
        </Menu>
      )}
    </>
  );
};

NavMenu.propTypes = {
  menu: PropTypes.shape({
    name: PropTypes.string,
    page: PropTypes.string.isRequired,
    childMenu: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        page: PropTypes.string.isRequired,
      })
    ),
  }).isRequired,
  onWorkspaceClick: PropTypes.func,
};

NavMenu.defaultProps = {
  onWorkspaceClick: null,
};

export default NavMenu;